<template>
    <SettingsSection :section="section" :index="index" :level="level" :isLoading="isLoading" :initiated="initiated"
        @debounceSave="debouncedAutoSave()" @instantSave="saveSettings">
        <template v-slot:settingList>
            <SettingRow v-for="setting in section.settingList" :key="section.key + setting.settingKey"
                :setting="setting" :loaded="!isLoading && initiated" :fetchLoading="isLoading"
                @debounceSave="debouncedAutoSave()" @instantSave="saveSettings">
            </SettingRow>
        </template>
    </SettingsSection>
</template>


<script>
//import SettingsConstants from '@/helpers/Constants/SettingsConstants';
import Section from "./Section.js"
import SettingRow from "./SettingRow.vue";
const SettingsSection = () => import("./SettingsSection.vue");

export default {
    name: "ServiceArticleSection",
    props: {
        section: Section,
        index: Number,
        level: Number,
        isLoading: Boolean,
        initiated: Boolean,
    },
    components: {
        SettingsSection,
        SettingRow,
    },
    mixins: [],

    data() {
        return {};
    },

    methods: {
        saveSettings(settingsArr) {
            this.$emit('instantSave', settingsArr)
        },

        debouncedAutoSave() {
            this.$emit('debounceSave')
        },
    },

    computed: { },

    watch: {},
};
</script>


<style lang="scss" scoped></style>